(function () {
  'use strict';

  function readJson(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (error) {
      return null;
    }
  }

  function eventId() {
    return 'tt_' + Date.now() + '_' + Math.random().toString(36).slice(2, 10);
  }

  function track(eventName, payload) {
    if (typeof window.ttq !== 'function' && !(window.ttq && window.ttq.track)) return;
    var data = Object.assign(
      {
        event_id: eventId(),
        url: window.location.href,
      },
      payload || {}
    );
    window.ttq.track(eventName, data);
  }

  function productPayload(product, variantId) {
    if (!product) return null;
    var value = product.value;
    if (variantId && product.variants && product.variants[String(variantId)] != null) {
      value = product.variants[String(variantId)];
    }
    return {
      contents: [
        {
          content_id: String(product.content_id),
          content_type: product.content_type || 'product',
          content_name: product.content_name,
        },
      ],
      value: value,
      currency: readJson('ds-tiktok-config')?.currency,
    };
  }

  function trackViewContent() {
    var product = readJson('ds-tiktok-product');
    if (!product) return;
    track('ViewContent', productPayload(product, product.variant_id));
  }

  function trackSearch() {
    var search = readJson('ds-tiktok-search');
    if (!search || !search.search_string) return;
    track('Search', {
      search_string: String(search.search_string),
      currency: readJson('ds-tiktok-config')?.currency,
    });
  }

  function trackPurchaseOnce() {
    var order = readJson('ds-tiktok-order');
    if (!order) return;
    var key = 'ds_tiktok_purchase_' + order.order_id;
    if (sessionStorage.getItem(key)) return;
    sessionStorage.setItem(key, '1');
    track('Purchase', {
      contents: order.contents || [],
      value: order.value,
      currency: order.currency,
    });
  }

  function trackAddToCart(variantId) {
    var product = readJson('ds-tiktok-product');
    if (!product) return;
    track('AddToCart', productPayload(product, variantId));
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (response) {
        return response.json();
      })
      .catch(function () {
        return null;
      });
  }

  function trackInitiateCheckout(cart) {
    if (!cart) return;
    var contents = (cart.items || []).map(function (item) {
      return {
        content_id: String(item.product_id),
        content_type: 'product',
        content_name: item.product_title,
        quantity: item.quantity,
      };
    });
    track('InitiateCheckout', {
      contents: contents,
      value: (cart.total_price || 0) / 100,
      currency: cart.currency || readJson('ds-tiktok-config')?.currency,
    });
  }

  function bindCheckoutClicks() {
    document.addEventListener(
      'click',
      function (event) {
        var target = event.target && event.target.closest
          ? event.target.closest('[name="checkout"], a[href*="/checkout"]')
          : null;
        if (!target) return;
        fetchCart().then(function (cart) {
          trackInitiateCheckout(cart);
        });
      },
      true
    );
  }

  function bindSearchForms() {
    document.querySelectorAll('form[action*="/search"]').forEach(function (form) {
      form.addEventListener('submit', function () {
        var input = form.querySelector('input[name="q"]');
        if (!input || !input.value) return;
        track('Search', {
          search_string: input.value.trim(),
          currency: readJson('ds-tiktok-config')?.currency,
        });
      });
    });
  }

  function bindCartUpdates() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (!event || event.source !== 'product-form') return;
      trackAddToCart(event.productVariantId);
    });
  }

  function init() {
    trackViewContent();
    trackSearch();
    trackPurchaseOnce();
    bindCheckoutClicks();
    bindSearchForms();
    bindCartUpdates();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
